import { render, staticRenderFns } from "./TestMailModal.vue?vue&type=template&id=070c2bf2"
import script from "./TestMailModal.vue?vue&type=script&lang=js"
export * from "./TestMailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports